import { actionTypes } from './action-types';
import { mutationTypes } from './mutation-types';
import { getterTypes } from './getter-types';
import { validateMessages } from '@/config';
import {userData, updateUserData, registerUser, resetPassword} from '@/services/user'

const UserModule = {
    namespaced: true,
    strict: true,
    state: {
        user: null,
        register_user: null,
    },
    actions: {
        [actionTypes.ADD_UPDATE_USER_DATA]({ dispatch }, data) {
            return new Promise((resolve, reject) => {
                updateUserData(data)
                    .then((response) => {
                        console.log('resp');
                        console.log(response);
                        dispatch(actionTypes.ADD_USER_DATA);
                        resolve(true);
                    })
                    .catch(() => {
                        reject(validateMessages.error.text);
                    });
            });
        },
        [actionTypes.ADD_USER_DATA]({ commit }) {
            return new Promise((resolve, reject) => {
                userData()
                    .then(response => {
                        const data = response.data;
                        commit(mutationTypes.SET_USER_DATA, data);
                        resolve(data);
                    })
                    .catch(() => {
                        reject(validateMessages.error.text);
                    });
            });
        },
        [actionTypes.CLEAR_USER_DATA]({ commit }) {
            commit(mutationTypes.SET_USER_DATA, null);
        },
        [actionTypes.RESET_PASSWORD]({ commit }, token, data) {
            return new Promise((resolve, reject) => {
                resetPassword(token, data)
                    .then(response => {
                        console.log(response);
                        commit(mutationTypes.RESET_PASSWORD, {});
                        resolve(true);
                    })
                    .catch(() => {
                        reject(validateMessages.error.text);
                    });
            });
        },
        [actionTypes.ADD_REGISTER_USER]({ commit }, data) {
            return new Promise((resolve, reject) => {
                registerUser(data)
                    .then(response => {
                        const data = response.data;
                        commit(mutationTypes.SET_REGISTER_USER, data);
                        resolve(data);
                    })
                    .catch(() => {
                        reject(validateMessages.error.text);
                    });
            });
        },
    },
    mutations: {
        [mutationTypes.SET_USER_DATA](state, payload) {
            state.user = payload;
        },
        [mutationTypes.SET_REGISTER_USER](state, payload) {
            state.register_user = payload;
        },
    },
    getters: {
        [getterTypes.GET_USER_DATA] (state) {
            return state.user;
        },
        [getterTypes.GET_REGISTER_USER] (state) {
            return state.register_user;
        },
    },
};

export { UserModule };
